import React, { useState } from 'react'
import { Spinner, Alert } from 'react-bootstrap'
import { API, Flash } from 'app'

export const useDataLoader = () => {
    const [data, setData] = useState({ payload: null, status: 'NULL', message: null }) // NULL -> LOADING -> SUCCESS / ERROR
    const callApi = API.useAPI()

    const set = (payload) => {
        setData({ payload, status: data.status, message:data.message })
    }
    const get = () => {
        return data.payload
    }
    const fetch = async (endpoint, params={}, onError='throw') => {
        try {            
            setData({ payload: null, status: 'LOADING', message: null })
            const payload = await callApi(endpoint, params, onError)
            setData({ payload, status: 'SUCCESS' })
        } catch (err) {
            setData({ payload: null, status: 'ERROR', message: err.message })
        }
    }

    const view = (renderFn = null, loadingFn = null, errorFn = null) => {
        if (data.status === 'LOADING') {
            if (loadingFn) {
                return loadingFn()
            } else {
                return <>
                        <div style={{textAlign:'center'}}>
                            <pre>Loading...</pre>
                            <Spinner animation='border' role='status'>
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    </>
            }
        } else if (data.status === 'ERROR') {
            if (errorFn) {
                return errorFn()
            } else {
                return <>
                        <div style={{textAlign:'center', fontFamily:'monospace'}}>
                            <Alert variant={'danger'} style={{display:'inline-block'}}>
                                Error: {data.message.split('\n').map((line, i) => <span key={i}>{line}<br/></span>)}
                            </Alert>
                        </div>
                    </>
            }
        } else if (data.status === 'SUCCESS') {
            if (renderFn) {
                return renderFn(data.payload)
            } else {
                return <pre>{ JSON.stringify(data, null, 2) }</pre>
            }
        }
    }
    return { get, set, fetch, view, data }
}